<template>
    <div class="content">
        <div class="title">
           {{caseData.title}}
        </div>
        <div class="caseDetailsBox">
            <div class="caseDetailsItem">
                <div class="caseDetailsTitle">
                    污染过程数据统计
                </div>
                <a-table
                        v-if="caseDetails"
                        :columns="caseColumns"
                        :dataSource="caseDetails"
                        rowKey="name"
                        :rowClassName="rowClassName"
                        :pagination="false"
                >
                    <div slot="startTime" slot-scope="startTime" class="type">
                        {{startTime  | YearDate}}
                    </div>
                    <div slot="endTime" slot-scope="endTime" class="type">
                        {{endTime | YearDate}}
                    </div>
                </a-table>

                <a-empty v-else/>
            </div>
            <div class="caseDetailsItem">
                <div class="caseDetailsTitle">
                    污染过程成因分析
                </div>
                <div class="caseMenuList">
                    <div class="caseMenuItem" v-for="item in CaseMenu" :key="item.menuId" @click="menuJump(item)">
                        <div class="caseMenuImg">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="caseMenuName">
                            {{item.title}}
                        </div>
                    </div>
                </div>

            </div>
            <div class="caseDetailsItem">
                <div class="caseDetailsTitle">
                    污染过程分析报告
                </div>
                <div class="reportHead">
                    <div class="reportSearchBox">
                        <div class="reportSearch">
                            <div class="searchPicker">
                                {{PickerList[PickerIndex].name}}
                                <div class="pickerIcon icon el-icon-caret-bottom"></div>
                                <div class="PickerList">
                                    <div class="PickerItem" v-for="(item,index) in PickerList" :key="index" @click="pickerChange(index)"> {{item.name}} </div>
                                    <!--                                <div class="PickerItem">时间</div>-->
                                </div>
                            </div>
                            <div class="searchInput">
                                <input v-if="PickerIndex===0" v-model="searchTitle" type="text" placeholder="输入报告标题">
                            </div>
                            <div class="searchBtn" @click="onSearch">
                                <div class="icon el-icon-search"></div>
                            </div>
                        </div>
                        <div class="reportAddBtn" @click="openAddReport">新建分析报告</div>
                    </div>
                </div>
                <a-table
                        v-if="reports"
                        :columns="columns"
                        :dataSource="reports"
                        rowKey="id"
                        :rowClassName="rowClassName"
                        :pagination="pagination"
                >
                    <!--                <div slot="img" slot-scope="coverImageUrl" class="img-wrap">-->
                    <!--                    <img v-if="coverImageUrl" :src="coverImageUrl | imgUrl(2) "/>-->
                    <!--                </div>-->
                    <div slot="reportName" slot-scope="title" class="title text-overflow">
                        {{title}}
                    </div>
                    <div slot="operation" slot-scope="operation,dataItem" class="type">
                        <template v-if="operation">
                            <a @click="viewReport(dataItem)">查看</a>
                        </template>
                        <template v-else>
                            <a v-if="dataItem.internalUrl" @click="openUrl(dataItem.internalUrl)" style="margin-right:10px;">查看报告</a>
                            <a @click="editReport(dataItem)" style="margin-right:10px;">编辑</a>
                            <a-popconfirm title="确认要删除本条报告吗？" @confirm="DeleteReport(dataItem)">
                                <a-icon slot="icon" type="question-circle-o" style="color: red;"/>
                                <a style="margin-right:10px;">删除</a>
                            </a-popconfirm>
                            <a v-if="dataItem.externalUrl" @click="openUrl(dataItem.externalUrl)" style="margin-right:10px;">外部链接</a>
                        </template>
                    </div>
                </a-table>

                <a-empty v-else/>

                <AddReportModal
                        ref="AddReport"
                        v-if="showAddReport"
                        :show.sync="showAddReport"
                        :processId.sync="caseData.processId"
                        :EditDisabled.sync="EditDisabled"
                        @updateShow="updateShow"
                />
            </div>

        </div>
    </div>
</template>

<script>
    import apiUrl from "../../utils/UrlApi"
    import AddReportModal from "./AddReportModal.vue";
    import moment from 'moment';

    export default {
        name: "caseDetails",
        components: {
            AddReportModal
        },
        data() {
            return {
                caseData:{},
                caseDetails: [],
                // caseColumns: [],
                 caseColumns: [
                     {
                         title: '开始时间', dataIndex: 'startTime', width: '12.5%', align: 'center',
                         scopedSlots: {customRender: 'startTime'}
                     },
                     {
                         title: '结束时间', dataIndex: 'endTime', width: '12.5%', align: 'center',
                         scopedSlots: {customRender: 'endTime'}
                     },
                    {title: '持续时间', dataIndex: 'day', width: '14%',  align:'center',},
                    {title: '污染类型', dataIndex: 'type', width: '14%',  align:'center',},
                    {title: '案例名称', dataIndex: 'name', width: '14%',  align:'center',},
                    {title: '首污', dataIndex: 'pollutionTime', width: '14%',  align:'center',},
                    {title: '污染等级', dataIndex: 'pollutionLevel', width: '14%',  align:'center',},
                ],



                reports: null,
                columns: [
                    {title: '序号', dataIndex: 'index', key: 'index', width: '10%',align:'center'},
                    {
                        title: '报告名称', dataIndex: 'title', key: 'title', width: '20%',align:'center',
                        scopedSlots: {customRender: 'title'}
                    },
                    {title: '单位', dataIndex: 'department', key: 'department', width: '10%',align:'center'},
                    {title: '作者', dataIndex: 'author', key: 'author', width: '10%',align:'center'},
                    {title: '来源', dataIndex: 'source', key: 'source', width: '10%',align:'center'},
                    // {title: '链接', dataIndex: 'url', key: 'url', width: '10%',},
                    {title: '时间', dataIndex: 'time', key: 'time', width: '10%',align:'center'},
                    {
                        title: '操作', dataIndex: 'operation', key: 'operation', width: '30%',align:'center',
                        scopedSlots: {customRender: 'operation'}
                    }
                ],
                pagination: {
                    page: 1,
                    pageSize: 10,
                    totalPage: 0,
                    total: 0,
                    onChange: (page) => this.pageChange(page)
                },
                searchTitle: null,
                PickerList:[
                    {name:'报告标题',id:1},
                    // {name:'时间',id:2},
                ],
                PickerIndex:0,
                showAddReport:false,
                EditDisabled:false,
                EditData:{
                    time:moment().format('YYYY-MM-DD'),
                    title:'',
                    department:'',
                    author:'',
                    source:'',
                    url:'',
                    remark:'',
                    processId:'',
                },
                CaseMenu:[],
            }
        },
        computed:{
          time:{
              get(){
                  return this.$route.query.date
              }
          },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            }
        },
        mounted(){
            this.getCalendarInfo()
            this.getCaseMenu()
        },
        methods: {

            getCaseMenu(){
                let params={
                }
                this.$http.get(apiUrl.caseMenu, {
                    params: params
                }).then(res => {
                    // console.log(res)
                    this.CaseMenu = res.data.data
                })
            },


            updateShow(){
                this.getCaseLibraryList()
            },
            pickerChange(index){
                this.PickerIndex= index
                this.searchReportName =''
                this.searchDate =''
                this.onSearch()
            },
            // 获取详情
            getCalendarInfo() {
                let params={
                    time:this.time
                }
                this.$http.get(apiUrl.calendarInfo, {
                    params: params
                }).then(res => {
                    // console.log(res)

                    if(res.data.code==200){
                        this.caseData = res.data.data
                        this.caseDetails =  res.data.data.list
                        //
                        // let caseColumns = []
                        // let caseDetailsObj = {}
                        // list.forEach(req=>{
                        //     caseColumns.push({
                        //         title: req.name,
                        //         dataIndex: req.keys,
                        //         align:'center',
                        //         width:(100/list.length) +'%'
                        //     })
                        //     caseDetailsObj[req.keys] = req.value
                        // })
                        //
                        // this.caseColumns = caseColumns
                        // this.caseDetails = [caseDetailsObj]

                        this.getCaseLibraryList(res.data.data.processId)

                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  获取 报告列表
            getCaseLibraryList(processId){
                let params={
                    page: this.pagination.page,
                    pageSize: this.pagination.pageSize,
                    processId: this.caseData.processId,
                    title:this.searchTitle
                }
                this.$http.get(apiUrl.caseLibraryList, {
                    params: params
                }).then(res => {
                    if(res.data.code==200){
                        this.reports = res.data.data.list;
                        if (this.reports && this.reports) {
                            this.reports.map((item, index) => {
                                item.index = index + 1;
                                item.key = item.id;
                                item.operation = item.releaseType;
                            })
                        }
                        let pageInfo = res.data.data;
                        // this.pagination.page = pageInfo.page;
                        // this.pagination.pageSize = pageInfo.pageSize;
                        this.pagination.total = pageInfo.totalCount;
                        this.pagination.totalPage = pageInfo.totalPage;
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            editReport(itemReport) {
              console.log(itemReport)
                this.EditDisabled = true
                this.showAddReport = true;

              itemReport.time = moment(itemReport.time).format('YYYY-MM-DD')

                this.$nextTick(() => {
                    this.$refs['AddReport'].initData(itemReport);
                });
              // console.log(this.$refs.AddReport)
                // this.$refs['AddReport'].initData(itemReport);
            },

            DeleteReport(itemReport){
                this.$http.post(apiUrl.caseLibraryDelete+'/'+itemReport.id).then(res => {
                    if(res.data.code==200){
                        this.$message.success(res.data.message);
                        this.getCaseLibraryList()
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            openAddReport() {
                this.showAddReport = true;
                this.EditDisabled = false
                let itemReport ={
                    time:moment().format('YYYY-MM-DD'),
                    title:'',
                    department:'',
                    author:'',
                    source:'',
                    url:'',
                    remark:'',
                    processId:'',
                }
                this.$nextTick(() => {
                    this.$refs['AddReport'].initData(itemReport);
                });
            },
            onSearch() {
                this.pageChange(1);
            },
            rowClassName(record, index) {
                let className = 'dark';
                if (index % 2 === 1) className = 'light';
                return className;
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getCaseLibraryList()
            },
            openUrl(url){
                window.open(url,'_blank')
            },
            menuJump(item){
                if(item.type===1){
                    this.$router.push({
                        name:'CityMonitor',
                        query:{
                            id:item.menuId,
                            startDate:this.caseData.startDate,
                            endDate:this.caseData.endDate,
                            seriousDate:this.caseData.seriousDate
                        }
                    })
                }else if (item.type===2){
                    this.$router.push({
                        name:'CauseAnalysis',
                        query:{
                            id:item.menuId,
                            startDate:this.caseData.startDate,
                            endDate:this.caseData.endDate,
                            seriousDate:this.caseData.seriousDate
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">

    .content{
        margin: 20px 60px;
        .title{
            text-align: center;
            font-size: 28px;
            padding: 10px 0;
        }
        .caseDetailsBox{
            min-width: 1000px;
            margin: 0 auto;
            .caseDetailsItem{
                margin: 20px 0;
                padding: 20px 0;
                border-bottom: 2px solid #ddd;
                .caseDetailsTitle{
                    margin-bottom: 10px;
                    font-weight: bold;
                    font-size: 18px;
                }

                .caseMenuList{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: stretch;
                    justify-content: space-between;

                    .caseMenuItem{
                        width: 18%;
                        text-align: center;
                        box-shadow: 0 0 0 2px #ddd;
                        margin: 20px 0;
                        cursor: pointer;
                        .caseMenuImg{
                            img{
                                width: 100%;
                            }
                        }
                        .caseMenuName{
                            padding: 20px 0;
                        }
                    }

                    .caseMenuItem:hover{
                        box-shadow: 0 0 0 4px #ddd;
                    }
                }
            }
        }
    }

    .reportHead{
        display: flex;
        //margin: 16px 0;
        margin-bottom: 16px ;
        justify-content: center;
        align-items: stretch;
        .reportSearchBox{
            display: flex;
            justify-content: center;
            align-items: stretch;
            padding: 4px;
            background-color: #DFE0E2;
            border-radius: 4px;
            .reportSearch{
                background-color: #fff;
                //box-shadow: 0px 0px 8px #666;
                //padding: 8px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                .searchPicker{
                    padding: 0 30px;
                    border-right: 2px solid #ccc;
                    position: relative;
                    cursor: pointer;
                    .pickerIcon{
                        position: absolute;
                        right: 4px;
                        font-size: 18px;
                        top: 50%;
                        margin-top: -9px;
                    }

                    .PickerList{
                        position: absolute;
                        display: none;
                        box-shadow: 0px 2px 4px #ddd;
                        left: 50%;
                        margin-left: -40px;
                        width: 80px;
                        background-color: #fff;
                        text-align: center;
                        padding: 10px 10px;
                        z-index: 999;
                        .PickerItem{
                            padding: 6px 0;
                            border-bottom: 1px solid #ddd;
                        }
                    }
                    .PickerList :last-child{
                        border-bottom:0;
                    }

                }

                .searchPicker:hover{
                    .PickerList{
                        display: block;
                    }
                }

                .searchInput{
                    input{
                        width: 320px;
                        line-height: 32px;
                        padding: 0 10px;
                    }
                }
                .searchBtn{
                    background-color: #EFEFEF;
                    line-height: 48px;
                    height: 48px;
                    padding: 6px 20px;
                    cursor: pointer;

                    .icon{
                        color: #528AE7;
                        font-size: 24px;
                        font-weight: bold;
                    }

                }
            }
            .reportAddBtn{
                background-color: #EFEFEF;
                line-height: 48px;
                border-radius: 4px;
                padding: 0 10px;
                //box-shadow: 0px 0px 4px #000;
                margin-left: 6px;
                cursor: pointer;
            }
        }
    }


    /deep/ .ant-table .light {
        background-color: white;
    }

    /deep/ .ant-table .dark {
        background-color: rgb(240, 240, 241);
    }

    /deep/ .ant-table-thead > tr > th {
        padding: 16px 0 !important;
    }

    /deep/ .ant-table-tbody > tr > td {
        padding: 16px 0 !important;
    }

</style>